import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { Divider, Drawer, Typography } from 'antd';
import styled from 'styled-components';

import { PrivateDocumentCategoryList } from '@/entities/privateDocuments';
import { Container } from '@/shared/components/layout';
import { COLORS } from '@/shared/constants/colors';
import { routes } from '@/shared/helpers';
import { useAppRouter } from '@/shared/hooks/app/useAppRouter';
import { PrivateDocumentCategory } from '@/shared/lib/sj-orm/models/document/private.document.dto';

import { useModalsStore } from '../../modals.store';
import { SelectPrivateDocumentCategoryModalProps } from '../../types';

export const SelectPrivateDocumentCategoryModal: FC<
  SelectPrivateDocumentCategoryModalProps
> = () => {
  const router = useAppRouter();
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'selectPrivateDocumentCategory' });
  const modals = useModalsStore();

  const handleClick = async (category: PrivateDocumentCategory) => {
    modals.closeModal();

    await router.pushShallow({
      pathname: routes.privateDocumentCreate(category),
      query: router.query,
    });
  };

  return (
    <StyledDrawer
      height={'80vh'}
      placement="bottom"
      closable={false}
      onClose={modals.closeModal}
      open={true}
    >
      <Container paddingX={24} paddingY={16}>
        <DrawerTitle>{t('title')}</DrawerTitle>
      </Container>
      <Divider style={{ margin: 0 }} />
      <PrivateDocumentCategoryList onSelect={handleClick} />
    </StyledDrawer>
  );
};

const StyledDrawer = styled(Drawer)`
  &&& {
    .ant-drawer-body {
      padding: 0;
    }
  }
`;

const DrawerTitle = styled(Typography.Text)`
  &&& {
    font-size: 16px;
    color: ${COLORS.colorTextTertiary};
  }
`;
